module.exports = new __parcel__URL__("dev-image.e3205522.png").toString();